import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import Card from 'components/Card';
import CardHeader from 'components/Card/Header';
import Children from 'containers/Children';
import Contact from './Contact';
import Interests from './Interests';
import Personal from './Personal';

import ProfilePage from '../Page';
import { GET_PROFILE_DETAIL } from '../../../schema/apolloQueries/profileQueries';

const styles = {
  card: {
    marginBottom: 10,
  },
};

const ProfileDetailsPage = () => {
  const [viewer, setViewer] = useState({
    loggedIn: false,
  });
  const [personalContact, setPersonalContact] = useState([]);
  const [childrens, setChildrens] = useState([]);
  const [intrests, setIntrests] = useState([]);

  const { data, loading } = useQuery(GET_PROFILE_DETAIL);

  useEffect(() => {
    if (data?.viewer) {
      setViewer(data?.viewer);
      setPersonalContact(data?.viewer);
      setIntrests(data?.getPersonCategoryInterests);
      setChildrens(data?.getUserChildren);
    } else {
      setViewer({
        loggedIn: false,
      });
    }
  }, [data]);

  return (
    <ProfilePage title='About Me' loading={loading}>
      <Card style={styles.card}>
        <CardHeader title='Personal' />
        <Personal viewer={personalContact} personId={viewer.personId} />
      </Card>
      <Card style={styles.card}>
        <CardHeader title='Contact' />
        <Contact viewer={personalContact} personId={viewer.personId} />
      </Card>
      <Card style={styles.card}>
        <CardHeader title='Children' />
        <Children viewer={childrens} personData={personalContact} personId={viewer.personId} />
      </Card>
      <Card style={styles.card}>
        <CardHeader title='Interests' />
        <Interests
          viewer={intrests}
          personId={viewer.personId}
        />
      </Card>
    </ProfilePage>
  );
};

export default ProfileDetailsPage;
